<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'user.user' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>
<div fxLayout="row" fxLayoutAlign="center">
  @if (isActionPending$ | async) {
    <mat-spinner></mat-spinner>
  }
</div>

@if (!(isActionPending$ | async) && user$ | async; as user) {
  <div>
    <mat-dialog-content>
      <form [formGroup]="userFormGroup" appReadOnlyWithoutPermission="ROLE_USER">
        <mat-form-field>
          <mat-label>{{ 'user.firstName' | translate }}</mat-label>
          <input matInput type="text" formControlName="firstName">
          <mat-error>{{ userFormGroup.get('firstName').getError('server') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.lastName' | translate }}</mat-label>
          <input matInput type="text" formControlName="lastName">
          <mat-error>{{ userFormGroup.get('lastName').getError('server') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.email' | translate }}</mat-label>
          <input matInput type="email" formControlName="email">
          <mat-error>{{ userFormGroup.get('email').getError('server') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.password' | translate }}</mat-label>
          <input
            matInput type="password"
            formControlName="plainPassword"
            >
          <mat-error>{{ userFormGroup.get('plainPassword').getError('server') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.roles.name' | translate }}</mat-label>
          <mat-select formControlName="roles" multiple>
            @for (role of userRoles; track role) {
              <mat-option [value]="role">{{ 'user.roles.' + role | translate }}</mat-option>
            }
          </mat-select>
          <mat-error>{{ userFormGroup.get('roles').getError('server') }}</mat-error>
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="accent" [disabled]="userFormGroup.invalid" (click)="persistUser()">
        <mat-icon>check</mat-icon>
        {{ 'user.actions.persist' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
